module.exports = __webpack_public_path__ + "static/media/play.b9ff8af5.png";